import { use_slice_workspace_billing } from '@/hooks/store/use_slices';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { md } from '@/utils/utils_html';
import { DTOworkspacePaymentTransactionStripe } from '@shared/dto/+workspace/workspace_payment_transaction.ts/dto_workspace_payment_transaction_stripe';
import { DTO__database_entity } from '@shared/dto/_database_entity/DTO__database_entity';
import { useTranslation } from 'react-i18next';
import { USListPaymentsHistoryItem } from './USListPaymentsHistoryItem';

export function USListPaymentsHistory() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  const { payment_transactions_map } = use_slice_workspace_billing(['payment_transactions_map']);

  function render_items(payments: DTOworkspacePaymentTransactionStripe[]) {
    return payments.map((item, index) => <USListPaymentsHistoryItem key={item._id} item={item} index={index} />);
  }

  function render_table() {
    const payments = Array.from(payment_transactions_map.values())
      .flatMap(innerMap => Array.from(innerMap.values()))
      .sort(DTO__database_entity.sort_by_created_at_newest_first);

    let out = <></>;

    if (payments.is_empty()) {
      out = <TABLE__empty />;
    } else {
      out = <div className="flex flex-col justify-start items-center h-full w-full overflow-auto">{render_items(payments)}</div>;
    }
    return out;
  }

  return (
    <div
      className={`${md(
        'h-[350px] min-h-[350px] w-full',
        ' max-h-[30vh] pt-2 w-full',
      )} mt-3  flex flex-col justify-center items-start  border-b border-component-border  text-page-foreground`}
    >
      <div className="text-xl">{t(i18n_page_settings_workspace.tabs.invoices.payments_history_component.title)}</div>
      <div
        className={`${md(
          ' px-2 justify-between',
          'gap-5 px-5 justify-start',
        )} border-b border-component-border  w-full min-h-[50px] flex flex-row items-center    mt-2`}
      >
        <span className={`${md('w-[45px] text-[10px]', 'w-[120px]')}  text-left`}>
          {t(i18n_page_settings_workspace.tabs.invoices.payments_history_component.table_base.column.status)}
        </span>
        <span className={`${md('w-[55px] text-[10px]', 'w-[120px]')}  text-left`}>
          {t(i18n_page_settings_workspace.tabs.invoices.payments_history_component.table_base.column.amount_total)}
        </span>
        <span className={`${md('w-[45px] text-[10px]', 'w-[120px]')}  text-left`}>
          {t(i18n_page_settings_workspace.tabs.invoices.payments_history_component.table_base.column.credits_amount)}
        </span>
        <span className={`${md('w-[45px] text-[10px]', 'w-[120px]')}  text-left`}>
          {t(i18n_page_settings_workspace.tabs.invoices.payments_history_component.table_base.column.balance_before)}
        </span>
        <span className={`${md('w-[45px] text-[10px]', 'w-[120px]')}  text-left`}>
          {t(i18n_page_settings_workspace.tabs.invoices.payments_history_component.table_base.column.balance_after)}
        </span>
        <span className={`${md('w-[70px] text-[10px]', 'w-[160px]')}  text-left`}>
          {t(i18n_page_settings_workspace.tabs.invoices.payments_history_component.table_base.column.date)}
        </span>
      </div>
      {render_table()}
    </div>
  );
}
